module.exports = "<app-coupon-list></app-coupon-list>\r\n"